import React from 'react';
import './PowerPractice.css';
import { Fade, Zoom } from 'react-awesome-reveal';
import practic from "./PracticImage.png"





const pillars = [
  {
    icon: '⚕️',
    title: 'Medical Coding',
    desc: 'ICD-10, CPT & HCPCS expertise across all specialties.',
  },
  {
    icon: '💳',
    title: 'Billing Services',
    desc: 'End-to-end revenue cycle management for practices.',
  },
  {
    icon: '🎓',
    title: 'Training Programs',
    desc: 'Industry-certified courses with placement support.',
  },
];

const PowerPractice = () => {
  return (
    <section className="power_pg_wrapper" id="about">

      {/* ── Ambient background orbs ── */}
      <div className="power_pg_orb power_pg_orb_1" />
      <div className="power_pg_orb power_pg_orb_2" />
      <div className="power_pg_orb power_pg_orb_3" />
      <div className="power_pg_grid_overlay" />

      <div className="power_pg_container">

        {/* ── LEFT — Image ── */}
        <Zoom direction="left" duration={1500} >
          <div className="power_pg_left">
            <div className="power_pg_img_wrap">
              <img
                src={practic}
                alt="Medical Professional"
                className="power_pg_image"
              />

             
            </div>
          </div>
        </Zoom>

        {/* ── RIGHT — Text ── */}
        <div className="power_pg_right">

          <Fade direction="up" duration={800} triggerOnce>
            <span className="power_pg_eyebrow">Who We Are</span>
          </Fade>

          <Fade direction="up" delay={100} duration={800} triggerOnce>
            <h2 className="power_pg_heading">
              We Power <em>Practices.</em><br />
              We Train Professionals.
            </h2>
          </Fade>

          <Fade direction="up" delay={200} duration={800} triggerOnce>
            <p className="power_pg_desc">
              Alphaingen is a leading medical coding and billing center, as well as a
              trusted training institution preparing the next generation of certified
              professionals. Whether you're a healthcare provider seeking accurate
              billing services or a student pursuing a career in healthcare revenue
              cycle management, Alphaingen has you covered.
            </p>
          </Fade>

          <div className="power_pg_pillars">
            {pillars.map((p, i) => (
              <Fade key={i} direction="up" delay={280 + i * 100} duration={700} triggerOnce>
                <div className="power_pg_pillar">
                  <span className="power_pg_pillar_icon">{p.icon}</span>
                  <div>
                    <h4 className="power_pg_pillar_title">{p.title}</h4>
                    <p  className="power_pg_pillar_desc">{p.desc}</p>
                  </div>
                </div>
              </Fade>
            ))}
          </div>


        </div>
      </div>
    </section>
  );
};

export default PowerPractice;